import React, { useState } from 'react'
import { editUserDetails } from '../../../Api Methods/Api';
import Input from '../../CustomDropDown/Input/Input';
import Button1 from '../../UI/Button/Button1';
import classes2 from "../../forms/InviteUserForm.module.css"
import classes from "./SetTag.module.css"
import { GetSingleDeviceData } from '../../../store/service-actions';
import { serviceActions } from "../../../store/service-Slice";
import { useDispatch } from 'react-redux';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'react-phone-number-input';
import { Button } from 'primereact/button';


const SetPhoneNumber = ({placeholder, successModal, errorModal, HandleCloseModal, HandleShowModal, userObject, setUserObject}) => {

    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    let prevNumber = placeholder
    if (prevNumber == 'Not provided'){
        prevNumber = null
    }
    const [phoneNumber, setPhoneNumber] = useState(prevNumber || "+44");
    const dispatch = useDispatch();

    const [showError, setShowError] = useState(false)
    const handleInputChange = (event) => {
        setPhoneNumber(event);
    };

    const handleCancel = () => {
        setPhoneNumber('');
        HandleCloseModal();
    };

    const handleSaveTag = async () => {
        const apiData = {
            token,
            client,
        }

        const body = {
            "userID": userObject.id,
            "columnName": "phoneNumber",
            "newValue": phoneNumber
        }

        if (isValidPhoneNumber(phoneNumber)){
            const response = await editUserDetails(apiData, body, dispatch);
            if (response) {
                HandleCloseModal();
                successModal("Phone number successfully updated");

                setUserObject((prevUserObject) => ({
                    ...prevUserObject,
                    phoneNumber
                }));

            } else {
                errorModal("Failed to update phone number, please try again")
            }
        } else {
            setShowError(true)
        }
    }

    return (
        <form className={classes2["container"]} method="dialog" >
            <ul className={classes2["inputs-list"]}>
                <div className={classes2.label}>Edit phone number</div>
                <li className={classes2["input-container"]}>

                {showError && <p className={classes2.errorMessage}>Please enter a valid phone number</p>}


                <div className={classes2.phoneInput}>
                    <PhoneInput
                        international
                        defaultCountry="GB"
                        value={phoneNumber}
                        onChange={setPhoneNumber}
                    />
                </div>
                </li>
                <div className={classes.form}>
                    <Button icon="pi pi-times" onClick={handleCancel} label="Cancel" severity='secondary'/>
                    <Button icon="pi pi-save" onClick={handleSaveTag} label="Save" severity='success'/>
                </div>
            </ul>
        </form>
    )
}

export default SetPhoneNumber;